module.exports = __webpack_public_path__ + "static/media/severity2.9c7df772.png";